import { useTranslation } from "react-i18next"
import { useSelector } from "react-redux"

import DropdownDateBlock from "../../../../../Components/Filters/DropdownDateBlock/DropdownDateBlock"
import InputComponent from "../../../../../Components/Input"
import Icon from "../../../../../Icon"
import { getCalculatedPeriod } from "../../../../../Utils/utils"
import { useMonitoringPeriodChange } from "../../../hooks/useMonitoringPeriodChange"
import BrandTag from "../../BrandTag/BrandTag"
import HealthSubpageHeader from "../../HealthSubpageHeader"

import styles from "./EpsSubpageHeader.module.less"

const EpsSubpageHeader = ({ brandLabel, brandImage, search, onSearch }) => {
  const { t } = useTranslation()
  const filters = useSelector((state) => state.health.filters)
  const handlePeriodChange = useMonitoringPeriodChange()

  return (
    <HealthSubpageHeader
      title={t("Estimated Program Status")}
      titleExtra={<BrandTag label={brandLabel} image={brandImage} />}
    >
      <InputComponent
        className={styles.search}
        prefix={<Icon type="search" />}
        placeholder="Search descriptor..."
        aria-label="Search descriptor"
        allowClear
        value={search}
        onChange={(e) => onSearch(e.target.value)}
      />
      <DropdownDateBlock
        id="period"
        customOverlayClassName="health-header-date-filter"
        label="Custom"
        iconType="calendar_days"
        setDropdownFilters={handlePeriodChange}
        dropdownFilters={getCalculatedPeriod(filters?.period)}
        presetId={filters?.__preset_period}
        inactive={false}
        alwaysShowLabel={false}
      />
    </HealthSubpageHeader>
  )
}

export default EpsSubpageHeader
